
import React from 'react';

export const RateCardTotalChargeActionComponent = ({ vehicle,
    delivery,
    rto,
    fuel,
    peakSeason,
    toll, durationCharge, distanceCharge, weightCharge }: any) => {
    const rent = vehicle ? 200 : null
    const total = [delivery, rto, fuel, peakSeason, toll, rent]
        .map(value => Number(value) || 0) // Convert all values to numbers, default to 0 if invalid
        .reduce((acc, curr) => acc + curr, 0); // Sum all valid numbers
    const grandTotal = [total, durationCharge, distanceCharge, weightCharge]
        .map(value => Number(value) || 0) // Convert all values to numbers, default to 0 if invalid
        .reduce((acc, curr) => acc + curr, 0);

    return (


        <div className="max-w-md mx-auto p-4 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Total Charges</h2>

            {/* Table for displaying charges */}
            <table className="w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border px-4 py-2">Types</th>
                        <th className="border px-4 py-2">Charges(₹)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="text-center">
                        <td className="border px-4 py-2">Basic Charge</td>
                        <td className="border px-4 py-2">₹ {total || 0} </td>
                    </tr>
                    <tr className="text-center">
                        <td className="border px-4 py-2">distance Charge</td>
                        <td className="border px-4 py-2">₹ {distanceCharge || 0} </td>
                    </tr>
                    <tr className="text-center">
                        <td className="border px-4 py-2">Weight Charge</td>
                        <td className="border px-4 py-2">₹ {weightCharge || 0}</td>
                    </tr>
                    <tr className="text-center">
                        <td className="border px-4 py-2">Duration Charge</td>
                        <td className="border px-4 py-2">₹ {durationCharge || 0} </td>
                    </tr>
                    <tr className="text-center bg-sky-200">
                        <td className="border px-4 py-2">Total</td>
                        <td className="border px-4 py-2">₹ {grandTotal}</td>
                    </tr>
                </tbody>
            </table>
            <div></div>
        </div>


    )
}
export default RateCardTotalChargeActionComponent;
